import { passwordChecks } from "../lib/password";

export function PasswordChecklist({
  password,
  confirm,
  className = "",
}: {
  password: string;
  confirm?: string;
  className?: string;
}) {
  const checks = passwordChecks(password);
  if (confirm !== undefined) {
    checks.push({
      label: "Lykilorðin stemma",
      met: password.length > 0 && password === confirm,
    });
  }

  return (
    <ul className={`mt-2 space-y-1 ${className}`}>
      {checks.map((c) => (
        <li
          key={c.label}
          className={`flex items-center gap-1.5 text-[11.5px] transition-colors ${
            c.met ? "text-[#16A75C]" : "text-muted-3"
          }`}
        >
          <span
            className={`grid h-4 w-4 place-items-center rounded-full border text-white ${
              c.met
                ? "border-[#16A75C] bg-[#16A75C]"
                : "border-line text-transparent"
            }`}
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </span>
          {c.label}
        </li>
      ))}
    </ul>
  );
}
